import axios, { AxiosRequestConfig } from 'axios';

import { transformIncomingData, transformOutgoingData } from './dataTransform';
import { transformError, transformSuccess } from './responseTransform';

export const axiosClient = axios.create({
  baseURL: `https://${window.env?.CARE_BASE_DOMAIN}`,
  headers: {
    'Referrer-Policy': 'strict-origin-when-cross-origin',
  },
  withCredentials: true,
});

axiosClient.interceptors.request.use((req) => {
  req.headers.Accept = 'application/json';

  return req;
});

axiosClient.interceptors.request.use((req) => {
  req.params = transformOutgoingData(req.params);

  return req;
});

axiosClient.interceptors.request.use((req) => {
  if (req.data) {
    req.data = transformOutgoingData(req.data);
  }

  return req;
});

axiosClient.interceptors.response.use((resp) => {
  if (resp.data) {
    resp.data = transformIncomingData(resp.data);
  }

  return resp;
});

export const requestWithQuery = async <T>(options: AxiosRequestConfig): Promise<T> => {
  const onSuccess = (response): T => transformSuccess<T>(response);

  const onError = (error) => Promise.reject(transformError(error));

  return axiosClient(options).then(onSuccess).catch(onError);
};
